export const isValidCollectionId = (id: any) => !!id && typeof id === 'string' && !/{{.+}}/.test(id);
